import React, { FC } from 'react';
import { Note } from '@/services/notes/notesServiceTypes';
import { format, parseISO } from 'date-fns';
import { IoClose } from 'react-icons/io5';

interface NoteProps {
  note: Note;
  onClickDelete: (id: string) => void;
}

const formatDate = (isoString: string): string => {
  const date = parseISO(isoString);
  return format(date, 'MMM dd, yyyy');
};

const NoteComponent: FC<NoteProps> = ({ note, onClickDelete }) => {
  return (
    <div className="group relative flex flex-col gap-0">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xxs font-bold text-white text-opacity-30">{formatDate(note.createdAt)}</p>
          <p className="max-w-96 text-sm font-semibold text-white text-opacity-50">{note.content}</p>
        </div>
        <IoClose
          onClick={() => onClickDelete(note.id)}
          className="mr-4 cursor-pointer text-lg text-ph-gray-silver opacity-0 transition-opacity duration-300 group-hover:opacity-100 hover:text-ph-red"
        />
      </div>
    </div>
  );
};

export default NoteComponent;
